import { takeEvery, call, put } from 'redux-saga/effects';
import {
    FETCH_SELECTED_FIELDS,
    FETCH_SELECTED_FIELDS_SUCCESS,
    SAVE_SELECTED_FIELDS,
    SAVE_SELECTED_FIELDS_SUCCESS,
    FETCH_USER_PREFERENCE,
    FETCH_USER_PREFERENCE_SUCCESS,
    FETCH_USER_PREFERENCE_FAIL,
    SAVE_USER_PREFERENCE,
    SAVE_USER_PREFERENCE_SUCCESS,
    SAVE_USER_PREFERENCE_FAIL
} from '../actions/userPreferenceActions';
import { gcApi } from '../config/axios';
import {
    FETCH_USER_PREFERENCE_DEP,
    RECEIVE_USER_PREFERENCE,
    REQUEST_USER_PREFERENCE,
    SET_USER_PREFERENCE_DEP
} from '../actions/ActionTypes';
import { receiveUserPreference, requestUserPreference } from '../actions';

import { handlingErrorCallback, handlingSuccessCallback } from './sagasUtils';

// worker
export function* fetchSelectedFieldsSaga(action) {
    try {
        const response = yield call(gcApi.get, `/userpreference-service/progressSummary/selectedFields`);
        yield put({
            type: FETCH_SELECTED_FIELDS_SUCCESS,
            selectedFields: response.data
        });
    } catch (e) {
        // Handling Error
    }
}

export function* saveSelectedFieldsSaga(action) {
    try {
        const response = yield call(
            gcApi.put,
            '/userpreference-service/progressSummary/selectedFields',
            action.payload.selectedFields
        );
        yield put({
            type: SAVE_SELECTED_FIELDS_SUCCESS,
            selectedFields: response.data
        });
    } catch (e) {
        // Handling Error
    }
}

export function* saveUserPreferenceSaga(action) {
    try {
        let putObj = {
            key: action.preferenceKey,
            value: action.userPreference
        };

        const response = yield call(gcApi.put, `/userpreference-service/${action.preferenceKey}`, putObj);

        yield call(handlingSuccessCallback, action.callback, response);

        yield put({
            type: SAVE_USER_PREFERENCE_SUCCESS,
            value: response.data.value,
            preferenceKey: response.data.key
        });
    } catch (e) {
        yield call(handlingErrorCallback, action.callback, e);

        yield put({
            type: SAVE_USER_PREFERENCE_FAIL,
            value: null,
            preferenceKey: action.preferenceKey
        });
    }
}

export function* fetchUserPreferenceSaga(action) {
    try {
        const response = yield call(gcApi.get, `/userpreference-service/${action.key}`);

        yield put({
            type: FETCH_USER_PREFERENCE_SUCCESS,
            value: response.data.value,
            preferenceKey: response.data.key
        });
        if (action.callback) {
            yield call(handlingSuccessCallback, action.callback, response);
        }
    } catch (e) {
        yield put({
            type: FETCH_USER_PREFERENCE_FAIL,
            value: null,
            preferenceKey: action.key
        });
        if (action.callback) {
            yield call(handlingErrorCallback, action.callback, e);
        }
    }
}

// @deprecated - Use the saga based fetchUserPreference in reducers/preference/preference
export function* fetchUserPreferenceSagaDeprecated({ key }) {
    try {
        yield put(requestUserPreference(REQUEST_USER_PREFERENCE));
        const response = yield gcApi.get('/userpreference-service/' + key);
        yield put(receiveUserPreference(RECEIVE_USER_PREFERENCE, response.data));
    } catch (e) {}
}

// @deprecated - Use the saga based saveUserPreference in reducers/preference/preference
export function* setUserPreferenceSagaDeprecated({ key, value }) {
    try {
        const response = yield gcApi.put(`/userpreference-service/${key}`, {
            key: key,
            value: value
        });
        yield put(receiveUserPreference(RECEIVE_USER_PREFERENCE, response.data));
    } catch (e) {}
}

// watcher
export const userPreferenceSagas = [
    takeEvery(FETCH_SELECTED_FIELDS, fetchSelectedFieldsSaga),
    takeEvery(SAVE_SELECTED_FIELDS, saveSelectedFieldsSaga),
    takeEvery(SAVE_USER_PREFERENCE, saveUserPreferenceSaga),
    takeEvery(FETCH_USER_PREFERENCE, fetchUserPreferenceSaga),
    takeEvery(FETCH_USER_PREFERENCE_DEP, fetchUserPreferenceSagaDeprecated),
    takeEvery(SET_USER_PREFERENCE_DEP, setUserPreferenceSagaDeprecated)
];
